import TimeRange from '../partial/time-range'

const creataData = (d , p = 4) => {
  let map = {}
  for(let i of d){
    let { lat , lng , count } = i
    let key = lat.toFixed(p) + ','+lng.toFixed(p)
    if(!map[key]) {
      map[key] = { count:0 , lat:parseFloat(lat.toFixed(p)) , lng:parseFloat(lng.toFixed(p)) }
    }
    map[key].count += 1
  }

  return Object.values( map )
}

export default {
  data(){
    return {
      params:{
        rangeTime:[]
      }
    }
  },
  methods:{
    search() {
      let { rangeTime , ...search } = this.params
      if( rangeTime ){
        search.startDate = rangeTime[0]
        search.endDate = rangeTime[1]
      }

      let params = search
      this.loading = true
      this.$request.statsLicense(search).then(resp => {
        console.log(creataData(resp.data))
        this.heatmap.setDataSet({
          data: creataData(resp.data),
          max: 100
        });
      })
    },
    reset(){

    },
    init(map){
      this.map = map

      this.heatmap = new AMap.Heatmap(map, {
          radius: 25, //给定半径
          opacity: [0, 0.8]
          /*,
          gradient:{
              0.5: 'blue',
              0.65: 'rgb(117,211,248)',
              0.7: 'rgb(0, 255, 0)',
              0.9: '#ffea00',
              1.0: 'red'
          }
           */
      });

      this.search()
      
    },
    handleChangeTime(){

    }
  },
  render(){
    return <div style="width:100%;height:100%;position:absolute;">
        <div class="control" style="position:absolute;top:12px;left:12px;z-index:1001;padding:8px;background:#fff;border-radius:2px;box-shadow:0 0 3px rgba(0,0,0,.15);">
          <TimeRange size="small" v-model={this.params.rangeTime} on-change={this.handleChangeTime} default-value="all" />
          <div class="flex" style="margin-top:8px;">
            <sl-area v-model={this.params.districtCode} data-type="code" placeholder="所在区域" />
            <div>
              <i-button type="primary" icon="ios-search" on-click={this.search}>搜索</i-button>,
              <i-button style="margin-left: 8px" on-click={this.reset}>重置</i-button>
            </div>
          </div>
        </div>
        <sl-amap class="map" view-mode="2d" zoom={4} on-ready={this.init} />
    </div>
  }
}